import { getOfferDataWeb } from "../store/actions/authAction";
import { setCartAction } from "../store/actions/cartAction";
import { getPromoVideoByType } from "../store/actions/dashboardAction";
import { getPriceConversionRate } from "../store/actions/priceConversionAction";
import {
  getPromotionalPujaChadhavaDashBoardListActive,
  getTemplePujaCategoryList,
} from "../store/actions/pujaAction";

import { getFiveMostPopularTempleList } from "../store/actions/templeAction";
import { setSelectedAddressId } from "../store/slices/userSlice";
import { CONSTANT_META_STRINGS, PROMOVIDEOTYPE } from "../utils/Constants";
import { updateMetaTagsAtClientEnd } from "../utils/HelperFunctions";
async function LoadInitialData(dispatch: any) {
  await Promise.all([
    dispatch(getPromotionalPujaChadhavaDashBoardListActive()),
    dispatch(getTemplePujaCategoryList()),
    dispatch(getOfferDataWeb()),
    dispatch(getPriceConversionRate(null)),
    dispatch(getPromoVideoByType(PROMOVIDEOTYPE.puja)),
    dispatch(getPromoVideoByType(PROMOVIDEOTYPE.chadhava))
  ]);
  // if (localStorage["cartInfo"]) {
  //     let cartInfoFromLocalStorage = JSON.parse(localStorage.getItem("cartInfo") || "")
  //     dispatch(setCartAction(cartInfoFromLocalStorage));
  // }
  if (localStorage["selectedAddressId"]) {
    let selectedAddressFromLocalStorage =
      localStorage.getItem("selectedAddressId") || null;
    dispatch(setSelectedAddressId(selectedAddressFromLocalStorage));
  }

  // UpdateMeta after load

  updateMetaTagsAtClientEnd({ ...CONSTANT_META_STRINGS });
}

export default LoadInitialData;
